import React from 'react';
import { Redirect } from 'react-router-dom'; 

const RedirectComponent = () => <Redirect to="/cliente/projetos/v2" />;

export default RedirectComponent;
